//过滤对象空字段
export function filterObjectEmpty(obj) {
  for (var i in obj) {
    if (obj[i] === null || obj[i] === undefined || obj[i] === '') {
      delete obj[i]
    }
  }
  return obj
}
//0-100
export function validate100Int(value) {
  let r = /^(0|[1-9][0-9]*)$/;
  if (r.test(value) && value < 100) {
    return true
  }
  return false
}
//0-100000000整数
export function validateInt(value) {
  let r = /^(0|[1-9][0-9]*)$/;
  if (r.test(value) && value < 100000000) {
    return true
  }
  return false
}

//整数或两位小数
export function validateIntOrTwoNum(value) {
  let r = /^(0|[1-9][0-9]*)(\.\d{1,2})?$/;
  if (r.test(value)) {
    return true
  }
  return false
}
//百分数
export function validatePercent(value) {
  let r = /^(100|[1-9]?\d(\.\d\d?\d?)?)%$|0$/;
  if (r.test(value)) {
    return true
  }
  return false
}
//求和
export function SUM(arr) {
  return arr.reduce(function(prev, curr, idx, arr){
    return prev + curr;
  });
}
//求平均值
export function Average(arr) {
  return arr.reduce(function(prev, curr, idx, arr){
    return prev + curr;
  })/arr.length;
}



// WEBPACK FOOTER //
// ./src/utils/index.js